
export const lessThenMaxSizeEncoded = (str, maxSize) => {
    if (typeof str === "string") {
        const encodedSize = (new TextEncoder().encode(str)).length;
        console.log(`Encoded size: ${encodedSize/1000}KB, Max size: ${maxSize/1000}KB, Less than max size: ${encodedSize <= maxSize}`)
        return encodedSize <= maxSize;
    }
    return false;
};